<bfa-tabs custom-classes="tabs" type="underline" [hideTabBarIfOneTab]="true" (activeTabPanelChange)="trackTabChange($event)">
	<!-- My Portfolios for ST -->
	<tab-panel *ngIf="myPortfoliosTemplate" [tab-title]="'My Portfolios' | dcr : 'MY_PORTFOLIOS_TAB'" [templateRef]="myPortfoliosTemplate"></tab-panel>

	<!-- Custom Models -->
	<ng-container *ngFor="let group of customModelGroups | keyvalue">
		<tab-panel [tab-title]="group.value | dcr : group.value + '_TAB'" [tooltip]="group.value + '_TAB_TOOLTIP'" [templateRef]="customModel"></tab-panel>
		<ng-template #customModel>
			<mp-model-list-container
				[allFamilies]="modelsPerCategory[group.key]"
				[mode]="mode"
				[(selectedModelPortfolios)]="selectedModelPortfolios"
				[showCheckboxes]="showCheckboxes"
				[allowMultiple]="allowMultiple"
				[pillsFilterType]="PillsFilterType.CUSTOM"
				[maxLimit]="maxLimit"
				[arrowLeft]="arrowLeft"
				[useDasPortfolioId]="useDasPortfolioId"
				(onModelSelected)="onModelPortfolioSelected()"
				[hidePills]="hidePills"
			>
			</mp-model-list-container>
		</ng-template>
	</ng-container>

	<!-- BlackRock Models -->
	<tab-panel [tab-title]="'BlackRock Models' | dcr : 'BLK_MODELS_TAB'" [tooltip]="'BLK_MODELS_TAB_TOOLTIP'" [templateRef]="blackRockModels"></tab-panel>
	<ng-template #blackRockModels>
		<mp-model-list-container
			[allFamilies]="modelsPerCategory['blackRock']"
			[mode]="mode"
			[(selectedModelPortfolios)]="selectedModelPortfolios"
			[showCheckboxes]="showCheckboxes"
			[allowMultiple]="allowMultiple"
			[pillsFilterType]="PillsFilterType.BLK"
			[maxLimit]="maxLimit"
			[arrowLeft]="arrowLeft"
			[hidePills]="hidePills"
			[useDasPortfolioId]="useDasPortfolioId"
			(onModelSelected)="onModelPortfolioSelected()"
		>
		</mp-model-list-container>
	</ng-template>

	<!-- Third Party Models -->
	<tab-panel
		*ngIf="modelsPerCategory['thirdParty']?.length"
		[tab-title]="'Non-BlackRock Models' | dcr : 'MORE_MODELS_TAB'"
		[tooltip]="'MORE_MODELS_TAB_TOOLTIP'"
		[templateRef]="moreModels"
	></tab-panel>
	<ng-template #moreModels>
		<mp-model-list-container
			[allFamilies]="modelsPerCategory['thirdParty']"
			[mode]="mode"
			[(selectedModelPortfolios)]="selectedModelPortfolios"
			[showCheckboxes]="showCheckboxes"
			[allowMultiple]="allowMultiple"
			[pillsFilterType]="PillsFilterType.TPM"
			[maxLimit]="maxLimit"
			[arrowLeft]="arrowLeft"
			[hidePills]="hidePills"
			(onModelSelected)="onModelPortfolioSelected()"
		>
		</mp-model-list-container>
	</ng-template>
</bfa-tabs>
